export default "/fonts/vendor/material-icons/iconmaterial-icons-round.woff2?c380809fd3677d7d690354355dc7e66e";